const CommandActionDefaultStyle = {
    type: "Style",
    styleType: "action_button",
    name: "Default-Action-Button",
    alias:"Styles/Default-Action-Button",
    text: "Preview Text",
    guiText: "Action Button",
    textColor: {r: 255, g: 255, b: 255, a: 1},
    backgroundColor: {r: 24, g: 103, b: 192, a: 1},
    backgroundHoverColor: {r: 8, g: 87, b: 160, a: 1},
    opacity: 1,
    fontFamily: "serif",
    fontSize: 24,
    VRMode: "scene-follow",
    NonVRMode: "camera-fix",
    parent: null,
    Scene: {
        position: [
            0.8,
            -1,
            -2
        ],
        quaternion: [
            0,
            0,
            0,
            1
        ],
        scaleMultiplier: 1
    },
    Camera: {
        maxWidth: 20,
        maxHeight: 50,
        bottom: 45,
        right: 3
    }
};

module.exports = {
    CommandActionDefaultStyle
}